/* eslint-disable no-sequences */
import axios from "axios";
import { appState, apiToken, apiUrl_forVendors } from "./constants";
const CancelToken = axios.CancelToken;
const storeId = appState?.auth?.storeId

// get vendors
export let cancelGetVendorsApi;
export async function getVendors(headers, query = "") {
    if (headers) {
        const vendors = await axios.get(
            apiUrl_forVendors + "vendors?" + query,
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    cancelGetVendorsApi = c;
                }),
            }
        );
        return vendors;
    } else {
        console.log("Please add required parameters");
    }
}

// get vendors detail
export let cancelGetVendorDetailsApi;
export async function getVendorDetails(headers, id) {
    if (headers && id) {
        const vendorData = await axios.get(apiUrl_forVendors + "vendor/" + id, {
            headers: { ...headers },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetVendorDetailsApi = c;
            }),
        });
        return vendorData;
    } else {
        console.log("Please add required parameters");
    }
}

// add vendors
export let cancelAddVendorApi;
export async function addVendor(headers, vendorsData) {
    if ((headers && vendorsData)) {
        const vendors = await axios.post(
            apiUrl_forVendors + "vendor",
            vendorsData,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelAddVendorApi = c;
                }),
            }
        );
        return vendors;
    } else {
        console.log("Please add required parameters");
    }
}

// update vendors
export let cancelEditVendorApi;
export async function editVendor(headers, vendorData) {
    if ((headers && vendorData)) {
        const vendors = await axios.put(
            apiUrl_forVendors + "vendor/" + vendorData.vendor_id,
            vendorData,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelEditVendorApi = c;
                }),
            }
        );
        return vendors;
    } else {
        console.log("Please add required parameters");
    }
}

// delete vendors
export let cancelDeleteVendorApi;
export async function deleteVendor(headers, id) {
    if (headers && id) {
        const vendors = await axios.delete(
            apiUrl_forVendors + "vendor/" + id,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteVendorApi = c;
                }),
            }
        );
        return vendors;
    } else {
        console.log("Please add required parameters");
    }
}
